
  const MARKER_COLORS = {
    SELECTED: "#22c55e",  // green-500
    DECLINED: "#ef4444",  // red-500
    TO_REVIEW: "#0086e6", // blue-400
  }

  // Heroicons micro: calendar-days (16x16 viewBox)
  const CALENDAR_PATH = "M4 1.75a.75.75 0 0 1 1.5 0V3h5V1.75a.75.75 0 0 1 1.5 0V3a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2V1.75ZM4.5 6a1 1 0 0 0-1 1v4.5a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-7Zm.75 2.75A.75.75 0 0 1 6 8h.01a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75ZM8 8a.75.75 0 0 0 0 1.5h.01a.75.75 0 0 0 0-1.5H8Zm2.25.75A.75.75 0 0 1 11 8h.01a.75.75 0 0 1 0 1.5H11a.75.75 0 0 1-.75-.75ZM6 10a.75.75 0 0 0 0 1.5h.01a.75.75 0 0 0 0-1.5H6Zm2.25.75A.75.75 0 0 1 9 10h.01a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75Z"

  // Heroicons micro: check (16x16 viewBox)
  const CHECK_PATH = "M12.416 3.376a.75.75 0 0 1 .208 1.04l-5 7.5a.75.75 0 0 1-1.154.114l-3-3a.75.75 0 0 1 1.06-1.06l2.353 2.353 4.493-6.74a.75.75 0 0 1 1.04-.207Z"

  // Heroicons micro: building-office (16x16 viewBox)
  const BUILDING_PATH = "M3.75 2A1.75 1.75 0 0 0 2 3.75v8.5c0 .966.784 1.75 1.75 1.75h8.5A1.75 1.75 0 0 0 14 12.25v-5.5A1.75 1.75 0 0 0 12.25 5h-1.5v-.75A1.75 1.75 0 0 0 9 2.5H3.75ZM9.5 4.25V5H9V3.75A.25.25 0 0 0 8.75 3.5H4a.25.25 0 0 0-.25.25v8.5c0 .138.112.25.25.25h1V10.5A.5.5 0 0 1 5.5 10h2a.5.5 0 0 1 .5.5v2h1.25a.25.25 0 0 0 .25-.25v-5.5a.25.25 0 0 0-.25-.25H9.5ZM5 5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1A.5.5 0 0 1 5 5Zm.5 1.5a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1ZM5 8a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1A.5.5 0 0 1 5 8Zm3.5-2.5a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1ZM9 8a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1A.5.5 0 0 1 9 8Z"

  const LOCATION_COLOR = "#4b5563" // gray-600

  function markerColor(wantsTour) {
    if (wantsTour === true) return MARKER_COLORS.SELECTED
    if (wantsTour === false) return MARKER_COLORS.DECLINED
    return MARKER_COLORS.TO_REVIEW
  }

  function createMarkerSvg(color, size, opacity, strokeWidth, iconPath) {
    const r = size / 2 - strokeWidth / 2
    let iconHtml = ""
    if (iconPath) {
      const iconScale = (size * 0.5) / 16
      const iconOffset = (size - 16 * iconScale) / 2
      iconHtml = `<g transform="translate(${iconOffset}, ${iconOffset}) scale(${iconScale})"><path fill="white" fill-rule="evenodd" clip-rule="evenodd" d="${iconPath}"/></g>`
    }
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 ${size} ${size}"><circle cx="${size/2}" cy="${size/2}" r="${r}" fill="${color}" fill-opacity="${opacity}" stroke="white" stroke-width="${strokeWidth}"/>${iconHtml}</svg>`
    return "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(svg)
  }

  function markerIcons(color, tourStatus) {
    const iconPath = tourStatus === "completed" ? CHECK_PATH : tourStatus === "scheduled" ? CALENDAR_PATH : null
    return {
      defaultIcon: {
        url: createMarkerSvg(color, 24, 0.9, 2, iconPath),
        scaledSize: new google.maps.Size(24, 24),
        anchor: new google.maps.Point(12, 12),
      },
      highlightedIcon: {
        url: createMarkerSvg(color, 32, 1, 3, iconPath),
        scaledSize: new google.maps.Size(32, 32),
        anchor: new google.maps.Point(16, 16),
      },
      dimmedIcon: {
        url: createMarkerSvg(color, 24, 0.3, 2, iconPath),
        scaledSize: new google.maps.Size(24, 24),
        anchor: new google.maps.Point(12, 12),
      },
    }
  }

  export default {
    async mounted() {
      const areaUnit = this.el.dataset.areaUnit
      if (!areaUnit) {
        throw new Error(
          "data-area-unit attribute is required on SurveyPropertiesMap element"
        )
      }
      this.areaUnit = areaUnit

      const currencySymbol = this.el.dataset.currencySymbol
      if (!currencySymbol) {
        throw new Error(
          "data-currency-symbol attribute is required on SurveyPropertiesMap element"
        )
      }
      this.currencySymbol = currencySymbol

      this.handleEvent("update-marker-colors", ({ properties }) => {
        this.updateMarkerColors(properties)
      })

      await this.renderMap()
    },

    async renderMap() {
      const properties = JSON.parse(this.el.dataset.properties || "[]")
      const existingLocations = JSON.parse(this.el.dataset.existingLocations || "[]")
      const fallbackCenter = JSON.parse(this.el.dataset.center || "{}")

      const t = (key) => window.I18n[key]
      const failedToLoadMap = t("Failed to load map")

      // Store markers by property ID for cross-highlighting
      this.markers = new Map()

      try {
        await window.Enaia.loadGoogleMaps()
        const firstPoint = properties[0] || existingLocations[0]
        const defaultCenter = firstPoint
          ? { lat: parseFloat(firstPoint.lat), lng: parseFloat(firstPoint.lng) }
          : { lat: parseFloat(fallbackCenter.lat || "39.8283"), lng: parseFloat(fallbackCenter.lng || "-98.5795") }
        const defaultZoom = firstPoint ? 12 : parseInt(fallbackCenter.zoom || "4", 10)

        const map = new google.maps.Map(this.el, {
          zoom: defaultZoom,
          minZoom: 3,
          backgroundColor: "#e8eef1",
          center: defaultCenter,
          mapTypeControl: true,
          mapTypeControlOptions: {
            position: google.maps.ControlPosition.TOP_RIGHT,
            style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
          },
          streetViewControl: true,
          streetViewControlOptions: {
            position: google.maps.ControlPosition.RIGHT_TOP,
          },
          fullscreenControl: true,
          fullscreenControlOptions: {
            position: google.maps.ControlPosition.RIGHT_TOP,
          },
          zoomControl: true,
          zoomControlOptions: {
            position: google.maps.ControlPosition.RIGHT_CENTER,
          },
          styles: window.Enaia.GoogleMapsStyles.DESATURATED_MAP_STYLES,
        })

        const bounds = new google.maps.LatLngBounds()
        const hook = this
        const infoWindow = new google.maps.InfoWindow({ disableAutoPan: true })

        // Inject CSS to style InfoWindow - more reliable than DOM manipulation
        const style = document.createElement("style")
        style.textContent = `
          .gm-style-iw-chr { display: none !important; }
          .gm-style-iw-c { padding: 0 !important; outline: none !important; }
          .gm-style-iw-d { overflow: hidden !important; padding: 0 !important; max-height: none !important; }
        `
        this.el.appendChild(style)

        properties.forEach((property) => {
          const position = {
            lat: parseFloat(property.lat),
            lng: parseFloat(property.lng),
          }

          const color = markerColor(property.wants_tour)
          const icons = markerIcons(color, property.tour_status)

          // Build tooltip HTML for InfoWindow
          function buildTooltipHtml(prop) {
            let html = `<div style="font-family:system-ui,sans-serif;font-size:12px;line-height:1.4;min-width:140px;padding:8px 10px">`
            html += `<div style="font-weight:600;font-size:13px;margin-bottom:2px">${prop.name}</div>`
            if (prop.address && prop.address !== prop.name) {
              html += `<div style="color:#6b7280">${prop.address}</div>`
            }
            const details = []
            if (prop.size) details.push(`${prop.size.toLocaleString()} ${hook.areaUnit}`)
            if (prop.asking_rate) details.push(`${hook.currencySymbol}${prop.asking_rate}/${hook.areaUnit}`)
            if (details.length) html += `<div style="color:#6b7280">${details.join(" · ")}</div>`

            // Status with colored dot
            const statusColor = prop.wants_tour === true ? "#22c55e" : prop.wants_tour === false ? "#ef4444" : "#0086e6"
            const statusLabel = prop.wants_tour === true ? t("Selected for tour") : prop.wants_tour === false ? t("Declined for tour") : t("To review")
            html += `<div style="margin-top:4px;display:flex;align-items:center;gap:4px"><span style="width:8px;height:8px;border-radius:50%;background:${statusColor};display:inline-block"></span>${statusLabel}</div>`

            // Tour date
            if (prop.tour_status === "completed" && prop.tour_date) {
              html += `<div style="color:#6b7280;font-size:11px">${t("Toured on %{date}").replace("%{date}", prop.tour_date)}</div>`
            } else if (prop.tour_status === "scheduled" && prop.tour_date) {
              html += `<div style="color:#6b7280;font-size:11px">${t("Tour scheduled for %{date}").replace("%{date}", prop.tour_date)}</div>`
            }
            html += `</div>`
            return html
          }

          const marker = new google.maps.Marker({
            position,
            map,
            icon: icons.defaultIcon,
            zIndex: 1,
          })

          // Store marker with all icon configs and color for cross-highlighting
          hook.markers.set(property.id, { marker, color, ...icons })

          bounds.extend(position)

          marker.addListener("click", () => {
            hook.pushEvent("show_details", { id: property.id })
          })

          // Add hover listeners for reverse cross-highlighting (map -> grid)
          // Also scale up the marker itself for consistent hover effect
          marker.addListener("mouseover", () => {
            // Highlight this marker and dim all others
            hook.highlightMarker(property.id)
            // Show styled InfoWindow tooltip
            infoWindow.setContent(buildTooltipHtml(property))
            infoWindow.open(map, marker)
            // Highlight the corresponding grid row
            window.dispatchEvent(
              new CustomEvent("survey-grid:highlight-row", {
                detail: { propertyId: property.id },
              })
            )
          })

          marker.addListener("mouseout", () => {
            // Reset all markers to default state
            hook.resetAllMarkers()
            // Close tooltip
            infoWindow.close()
            // Unhighlight the corresponding grid row
            window.dispatchEvent(
              new CustomEvent("survey-grid:unhighlight-row", {
                detail: { propertyId: property.id },
              })
            )
          })
        })

        // Render existing locations as gray markers with building icon
        existingLocations.forEach((location) => {
          const position = {
            lat: parseFloat(location.lat),
            lng: parseFloat(location.lng),
          }

          const defaultIcon = {
            url: createMarkerSvg(LOCATION_COLOR, 28, 0.9, 2, BUILDING_PATH),
            scaledSize: new google.maps.Size(28, 28),
            anchor: new google.maps.Point(14, 14),
          }
          const highlightedIcon = {
            url: createMarkerSvg(LOCATION_COLOR, 36, 1, 3, BUILDING_PATH),
            scaledSize: new google.maps.Size(36, 36),
            anchor: new google.maps.Point(18, 18),
          }

          const marker = new google.maps.Marker({
            position,
            map,
            title: location.name,
            icon: defaultIcon,
            zIndex: 0,
          })

          marker.addListener("mouseover", () => {
            marker.setIcon(highlightedIcon)
            marker.setZIndex(1000)
            hook.showGlow(marker, LOCATION_COLOR)
          })

          marker.addListener("mouseout", () => {
            hook.removeGlow()
            marker.setIcon(defaultIcon)
            marker.setZIndex(0)
          })
        })

        if (properties.length > 1) {
          map.fitBounds(bounds)
          const listener = google.maps.event.addListener(map, "idle", () => {
            if (map.getZoom() > 15) map.setZoom(15)
            google.maps.event.removeListener(listener)
          })
        } else if (properties.length === 0 && existingLocations.length > 0) {
          // No survey options - fit to existing locations instead
          const locBounds = new google.maps.LatLngBounds()
          existingLocations.forEach((loc) => {
            locBounds.extend({ lat: parseFloat(loc.lat), lng: parseFloat(loc.lng) })
          })
          map.fitBounds(locBounds)
        }

        // Set up cross-highlighting event listeners
        this.setupHighlightListeners()
      } catch (error) {
        console.error("Error loading Google Maps:", error)
        this.el.innerHTML = `<div class="flex items-center justify-center h-full text-red-500">${failedToLoadMap}</div>`
      }
    },

    // Highlight a specific marker and dim all others
    highlightMarker(propertyId) {
      this.removeGlow()
      this.markers.forEach((data, id) => {
        if (id === propertyId) {
          // Highlight the target marker and bring to front
          data.marker.setIcon(data.highlightedIcon)
          data.marker.setZIndex(1000)
          // Add pulsating glow behind the marker
          this.showGlow(data.marker, data.color)
        } else {
          // Dim all other markers
          data.marker.setIcon(data.dimmedIcon)
          data.marker.setZIndex(1)
        }
      })
    },

    // Reset all markers to default state
    resetAllMarkers() {
      this.removeGlow()
      this.markers.forEach((data) => {
        data.marker.setIcon(data.defaultIcon)
        data.marker.setZIndex(1)
      })
    },

    // Show pulsating glow behind a marker
    showGlow(marker, color) {
      if (!this.glowOverlay) {
        const mapDiv = this.el
        // Inject keyframes once
        if (!document.getElementById("survey-glow-keyframes")) {
          const style = document.createElement("style")
          style.id = "survey-glow-keyframes"
          style.textContent = `
            @keyframes survey-marker-glow {
              0% { transform: translate(-50%, -50%) scale(1); opacity: 0.6; }
              50% { transform: translate(-50%, -50%) scale(1.8); opacity: 0; }
              100% { transform: translate(-50%, -50%) scale(1); opacity: 0.6; }
            }
          `
          document.head.appendChild(style)
        }
        this.glowOverlay = new google.maps.OverlayView()
        this.glowOverlay.onAdd = function() {
          this.div = document.createElement("div")
          this.div.style.position = "absolute"
          this.div.style.pointerEvents = "none"
          this.getPanes().overlayLayer.appendChild(this.div)
        }
        this.glowOverlay.draw = function() {
          if (!this.position || !this.div) return
          const projection = this.getProjection()
          const pos = projection.fromLatLngToDivPixel(this.position)
          this.div.style.left = pos.x + "px"
          this.div.style.top = pos.y + "px"
        }
        this.glowOverlay.onRemove = function() {
          if (this.div) { this.div.remove(); this.div = null }
        }
        this.glowOverlay.setMap(marker.getMap())
      }
      this.glowOverlay.position = marker.getPosition()
      // Wait for overlay to be added before updating content
      const overlay = this.glowOverlay
      const updateGlow = () => {
        if (!overlay.div) { requestAnimationFrame(updateGlow); return }
        overlay.div.innerHTML = `<div style="
          width: 40px; height: 40px;
          border-radius: 50%;
          background: ${color};
          position: absolute;
          left: 50%; top: 50%;
          transform: translate(-50%, -50%);
          animation: survey-marker-glow 1.5s ease-in-out infinite;
          filter: blur(4px);
          pointer-events: none;
        "></div>`
        overlay.draw()
      }
      requestAnimationFrame(updateGlow)
    },

    // Remove the glow overlay
    removeGlow() {
      if (this.glowOverlay) {
        this.glowOverlay.setMap(null)
        this.glowOverlay = null
      }
    },

    // Update marker colors based on new property data (after feedback change)
    updateMarkerColors(properties) {
      if (!this.markers) return

      properties.forEach((property) => {
        const entry = this.markers.get(property.id)
        if (!entry) return

        const color = markerColor(property.wants_tour)
        const icons = markerIcons(color, property.tour_status)
        Object.assign(entry, { color, ...icons })
        entry.marker.setIcon(icons.defaultIcon)
      })
    },

    setupHighlightListeners() {
      const hook = this

      this.highlightHandler = (event) => {
        const propertyId = event.detail.propertyId
        hook.highlightMarker(propertyId)
      }

      this.unhighlightHandler = (event) => {
        hook.resetAllMarkers()
      }

      window.addEventListener("survey-map:highlight-property", this.highlightHandler)
      window.addEventListener("survey-map:unhighlight-property", this.unhighlightHandler)
    },

    destroyed() {
      if (this.highlightHandler) {
        window.removeEventListener("survey-map:highlight-property", this.highlightHandler)
      }
      if (this.unhighlightHandler) {
        window.removeEventListener("survey-map:unhighlight-property", this.unhighlightHandler)
      }
    },
  }
